'use client';

import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

// Deferred so the devtools bundle stays out of the module graph everywhere it is never rendered —
// notably every Vitest fork, which imports this provider through the shared test wrapper.
// Client-only: an SSR-ed devtools container hydrates late, after an open MUI Dialog has already
// set `aria-hidden` on it, which React reports as a hydration mismatch.
const ReactQueryDevtools = dynamic(
  () =>
    import('@tanstack/react-query-devtools').then(({ ReactQueryDevtools: Devtools }) => Devtools),
  { ssr: false },
);

export const ReactQueryProvider = (props: { children: React.ReactNode }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 15 * 1000,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
      {props.children}
    </QueryClientProvider>
  );
};
